import { JobSubscriptionsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from '../types/TCall';
import type { notificationsKeys } from './notificationsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof notificationsKeys.jobSubscriptionsList>>;

export const createFetchJobSubscriptionsQueryFn =
  (call: TCall) =>
  ({ signal }: TParams) =>
    call(() => cancelOnSignal(JobSubscriptionsService.getList(), signal));
